import React, { useEffect, useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import {
  Menu,
  MenuItem,
  Button,
  IconButton,
  Typography,
  Toolbar,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import jwtDecode from "jwt-decode";
import { logout } from "../../api/auth.jsx";
import { useLocation } from "react-router-dom";
import { getCurrentDate } from "../../helper/index.jsx";

const drawerWidth = 240;

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function TopBar({ toggleDrawer, open }) {
  const location = useLocation();
  const [label, setLabel] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  let user = {};
  const token = localStorage.getItem("token");
  if (token) {
    user = jwtDecode(token);
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getHeader = (path) => {
    switch (path) {
      case "/":
        setLabel("Dashboard");
        break;
      case "/request-obat":
        setLabel("Request Obat");
        break;
      case "/data-obat":
        setLabel("Data Obat");
        break;
      case "/rekam-medis":
        setLabel("Rekam Medis");
        break;
      case "/body-composition":
        setLabel("Body Composition");
        break;
      case "/swab":
        setLabel("SWAB");
        break;
      default:
        setLabel("None");
        break;
    }
  };

  useEffect(() => {
    getHeader(location.pathname);
  });

  return (
    <AppBar position="absolute" open={open}>
      <Toolbar
        sx={{
          pr: "24px", // keep right padding when drawer closed
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: "36px",
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
        >
          {label}
        </Typography>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
        >
          {getCurrentDate()}
        </Typography>

        <Button
          id="demo-customized-button-a"
          aria-controls={openMenu ? "demo-customized-menu-a" : undefined}
          aria-haspopup="true"
          aria-expanded={openMenu ? "true" : undefined}
          variant="contained"
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
        >
          {user !== null ? user.user.role : "General"}
        </Button>

        <StyledMenu
          id="demo-customized-menu-a"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button-a",
          }}
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleClose}
        >
          <MenuItem onClick={logout} disableRipple>
            <LogoutIcon />
            LogOut
          </MenuItem>
        </StyledMenu>
      </Toolbar>
    </AppBar>
  );
}
